export const MESSAGE_DATE_FORMAT = 'YYYY/MM/DD HH:mm'
